<template>
 <div :class="$style.passwordForm">
    <pt-form-item label="旧密码" :required="true" :labelWidth="labelWidth">
      <el-input v-model="currentForm.currentPassword" name="currentPassword" v-validate="'required'" data-vv-as="旧密码" placeholder="请输入旧密码"></el-input>
    </pt-form-item>
    <pt-form-item label="新密码" :required="true" :labelWidth="labelWidth">
      <el-input v-model="currentForm.newPassword" name="newPassword" ref="新密码" type="password" v-validate="'required'" placeholder="请输入新密码"></el-input>
    </pt-form-item>
    <pt-form-item label="确认新密码" :required="true" :labelWidth="labelWidth">
      <el-input v-model="currentForm.newPasswordCopy" name="newPasswordCopy" type="password" v-validate="'required|confirmed:新密码'" data-vv-as="确认密码" placeholder="请输入新密码"></el-input>
    </pt-form-item>
 </div>
</template>

<script>
import formMixins from 'mixins/form'
export default {
  mixins: [formMixins],
  data () {
    return {
      labelWidth: '100px',
      currentForm: this.value ? this.value : {}
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    value (val) {
      this.currentForm = val
    },
    currentForm (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style module lang="less">
.passwordForm{
    width: 500px;
    margin-bottom: 20px;
}
</style>
